/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'
import SVG from 'react-inlinesvg'
import { toAbsoluteUrl, checkIsActive } from '../../_metronic/_helpers'

export function AsideMenuList({ layoutProps }) {
  const location = useLocation()
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && 'menu-item-active'} menu-item-open `
      : ''
  }

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive('/dashboard', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            {/*<span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl('/media/svg/icons/Design/Layers.svg')} />
            </span>*/}
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive('/Report')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/Report">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Report</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive('/PrivilegeSettingToYou')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/PrivilegeSettingToYou">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Privilege Setting</span>
          </NavLink>
        </li>

        {/* <li
          className={`menu-item ${getMenuItemActive('/QrCode')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/QrCode">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Generate QR Code Menu</span>
          </NavLink>
        </li> */}

        {/*<li
          className={`menu-item ${getMenuItemActive('/EventType')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/EventType">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Event Type Management</span>
          </NavLink>
        </li>*/}


        {/* <li
          className={`menu-item ${getMenuItemActive('/Weeklypass')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/Weeklypass">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Weekly Checkin Management</span>
          </NavLink>
        </li> */}

        <li
          className={`menu-item ${getMenuItemActive('/BannerManagement')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/BannerManagement">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Banner Management</span>
          </NavLink>
        </li>

        {/*<li
          className={`menu-item ${getMenuItemActive('/TargetGroup')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/TargetGroup">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Target Group Management</span>
          </NavLink>
        </li>*/}

        {/* <li
          className={`menu-item ${getMenuItemActive('/SpecialCampaign')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/SpecialCampaign">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Special campaign Management</span>
          </NavLink>
        </li> */}

        {/* <li
          className={`menu-item ${getMenuItemActive('/Notification')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/Notification">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Notification</span>
          </NavLink>
        </li> */}

        {/*<li
          className={`menu-item ${getMenuItemActive('/LineNotification')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/LineNotification">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Line Messages</span>
          </NavLink>
        </li>*/}


        {/* <li
          className={`menu-item ${getMenuItemActive('/TargetGroupPrivilege')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/TargetGroupPrivilege">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Privilege Target Group</span>
          </NavLink>
        </li> */}

        <li
          className={`menu-item ${getMenuItemActive('/AddPoint')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/AddPoint">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Add Point</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/UserManagement')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/UserManagement">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">User Management</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/TransactionLog')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/TransactionLog">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Transaction</span>
          </NavLink>
        </li>

        {/*<li
          className={`menu-item ${getMenuItemActive('/TargetGroup')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/TargetGroup">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Target Grouup</span>
          </NavLink>
        </li>*/}

        {/* Components */}
        {/* begin::section */}
      </ul>
      {/* end::Menu Nav */}
    </>
  )
}
